import React, {
  useCallback, useEffect,
  useMemo, useState,
} from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { compareText } from '../comparators/compareText';
import { TextFilter } from '../filters/TextFilter';
import 'draft-js/dist/Draft.css';
import {Stack, TextField} from '@mui/material';
import MinimizedTextEditor from './MinimizedTextEditor';
import { convertFromRaw } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import {debounce} from "lodash";

const parseJsonToEditorState = (jsonData: any) => {
  const contentState = convertFromRaw(JSON.parse(jsonData)); // Visszaalakítjuk a JSON-t ContentState-re
  const html = stateToHTML(contentState); // A ContentState HTML-re alakítása
  return html;
};

const isJsonString = (str: string): boolean => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};

export const SPMinimizedRichTextField: FieldComponent<string, string[]> = ({
  onChange,
  defaultValue,
  column,
}) => {

  const [currentState, setCurrentState] = useState<any>({
    value: undefined,
    send: false,
  });

  const debouncedChange = useCallback(
    debounce((newValue) => {
      onChange(newValue);
    }, 300),
    []
  );

  useEffect(() => {
    if (defaultValue) {
      setCurrentState({
        value: defaultValue,
        send: false,
      });
    }
  }, [defaultValue]);

  useEffect(() => {
    if (currentState.send) {
      debouncedChange(currentState.value);
    }
  }, [currentState, debouncedChange]);

  const handleChange = (value: any) => {
    setCurrentState({
      value: value,
      send: true,
    });
  };

  return (
    <Stack
      className="w-full"
      sx={{
        position: 'relative',
      }}
    >
      <TextField
        size={'small'}
        onChange={(event) => {
          const value = event.target.value;
          handleChange(value);
        }}
        onClick={(event:any)=>{
          const url = event.target.value;
          if (url) {
            window.open(url, '_blank');
          }
        }}
        defaultValue={defaultValue}
      />
    </Stack>
  );
};

SPMinimizedRichTextField.includes = (query = [], value = '') => {
  if (query.length === 0 || value === null) return true;
  const valueLowercase = value.toLowerCase();
  return query.some((queryPart) =>
    valueLowercase.includes(queryPart.toLowerCase())
  );
};

SPMinimizedRichTextField.comparator = compareText;

SPMinimizedRichTextField.FilterRenderer = TextFilter;
